import { isH5 } from "@saas/components/src";
export default {
  data: function () {
    return {
      isH5: isH5(),
      navList: [
        {
          name: "课程",
          pcName: "我的课程",
          key: "myCourse",
          component: ["myCourse", "myCourseDetail"],
          activeImg: require("../../../assets/images/learning-center/course-active.png"),
          image: require("../../../assets/images/learning-center/course.png"),
          mobileShow: true,
        },
        {
          name: "课表",
          pcName: "我的日历",
          key: "liveCalendar",
          component: "liveCalendar",
          activeImg: require("../../../assets/images/learning-center/ke-biao-active.png"),
          image: require("../../../assets/images/learning-center/ke-biao.png"),
          mobileShow: true,
        },
        // {
        //   name: "交易",
        //   key: "Trade",
        //   component: "Trade",
        //   activeImg: require("../../../assets/images/learning-center/trade-active.png"),
        //   image: require("../../../assets/images/learning-center/trade.png"),
        //   mobileShow: false,
        // },
      ],
      isElectron: window.isElectron,
    };
  },
  mounted() {
    console.log(this.$route.name);
  },
  methods: {
    handleClickTab(obj) {
      this.$router.push({ name: obj.key });
    },
  },
};
